import { render } from "./FileForm.vue?vue&type=template&id=40af7ad8"
import script from "./FileForm.vue?vue&type=script&lang=js"
export * from "./FileForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__